import { DictionaryItem } from "services/dictionaryService";

export const filterDictionaryItems = (
  dictionaryItems: DictionaryItem[],
  entities?: readonly string[]
) =>
  dictionaryItems &&
  dictionaryItems.filter((item) => (entities || []).includes(item.code));
